import { SHIPMENT_CLASSIFICATION } from '../constants'

export const setShipmentClassification = (signature, result) => ({
	type: SHIPMENT_CLASSIFICATION.SET,
	signature,
	result,
})

export const clearShipmentClassification = () => ({
	type: SHIPMENT_CLASSIFICATION.CLEAR,
})